import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AppConfigurationService } from 'src/app/core/services/app-configuration.service';
import { EnrollmentDetail } from '../models/enrollment-detail';
import { Enrollment } from '../models/enrollment.model';
import { EnrollmentNewRequest } from '../models/api/enrollment-new-request.model';

@Injectable({
    providedIn: 'root'
})
export class EnrollmentService {

    private readonly apiURL: string;

    constructor(private readonly http: HttpClient, private readonly appConfigurationService: AppConfigurationService) {

        this.apiURL = this.appConfigurationService.baseApi + '/enrollment';

    }

    get() {

        const url = this.apiURL;
        return this.http.get<Enrollment[]>(url);

    }

    getById(enrollmentId: number) {

        const url = `${this.apiURL}/id/${enrollmentId}`;
        return this.http.get<EnrollmentDetail>(url);

    }

    getByCode(enrollmentCode: string) {

        const url = `${this.apiURL}/code/${enrollmentCode}`;
        return this.http.get<EnrollmentDetail>(url);

    }

    getEnrollmentData() {

        const url = this.apiURL + '/getEnrollmentData';
        return this.http.get<number[]>(url);

    }

    post(newEnrollment: EnrollmentNewRequest) {

        const url = this.apiURL;
        return this.http.post<any>(url, JSON.stringify(newEnrollment));

    }

    updatePayment(enrollmentCode: string) {

        const url = `${this.apiURL}/update-payment/${enrollmentCode}`;
        return this.http.put<boolean>(url, null);

    }

}
